'use client';
import dynamic from 'next/dynamic';
import React from 'react';
import { FirebaseProvider } from '@/lib/firebase/FirebaseProvider';
import { XAdsAttributionCapture } from '@/components/XAdsAttributionCapture';
import { XAdsTag } from '@/components/XAdsTag';
import { usePathname } from 'next/navigation';

const App = dynamic(() => import('./app'), { ssr: false });

export default function Application({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  const isStandaloneWithdrawSignPage = /^\/admin\/withdraw-apply\/[^/]+\/sign\/?$/.test(pathname);
  const isStandaloneWithdrawApplyPage = /^\/admin\/withdraw-apply\/?$/.test(pathname);
  // 应用下载落地页：公开营销页，绕过 App 外壳（无侧边栏/Header），自带深色主题，包体最小
  const isDownloadPage = /^\/download\/?$/.test(pathname);
  // Loop 3 邀请落地页 W-Invite（/i/<码>）：同样是公开营销页，绕过 App 外壳
  const isInviteLandingPage = /^\/i\/[^/]+\/?$/.test(pathname);
  // 签名 URL 携带 bearer token，不能在此页加载第三方广告脚本。
  const tracking = isStandaloneWithdrawSignPage ? null : (
    <>
      <XAdsTag />
      <XAdsAttributionCapture />
    </>
  );

  if (
    isStandaloneWithdrawSignPage ||
    isStandaloneWithdrawApplyPage ||
    isDownloadPage ||
    isInviteLandingPage
  ) {
    return (
      <>
        {tracking}
        {children}
      </>
    );
  }

  return (
    <>
      {tracking}
      <FirebaseProvider>
        <App>{children}</App>
      </FirebaseProvider>
    </>
  );
}
